import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, Check } from 'lucide-react';
import { Button } from '../ui/button';

const languages = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
];

const LanguageSwitcher = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    // Set document direction for RTL support
    const lang = languages.find(l => l.code === langCode);
    document.documentElement.dir = lang?.dir || 'ltr';
    document.documentElement.lang = langCode;
    // Save to localStorage
    localStorage.setItem('i18nextLng', langCode);
    setIsOpen(false);
    // Force page reload to apply changes
    window.location.reload();
  };

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <div className="relative">
      <Button 
        variant={variant === 'ghost' ? 'ghost' : 'outline'} 
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className={variant === 'ghost' 
          ? 'text-zinc-300 hover:text-white hover:bg-zinc-800' 
          : 'border-zinc-700 text-zinc-300 hover:bg-zinc-800'
        }
        data-testid="language-switcher"
      >
        <Globe className="h-4 w-4 mr-2" />
        {currentLang.nativeName}
      </Button>
      
      {isOpen && (
        <>
          {/* Backdrop to close dropdown when clicking outside */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown Menu */}
          <div className="absolute top-full right-0 mt-2 w-48 bg-zinc-900 border border-zinc-700 rounded-lg shadow-xl z-50 overflow-hidden">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`w-full px-4 py-3 text-left flex items-center justify-between hover:bg-zinc-800 transition-colors ${
                  i18n.language === lang.code ? 'bg-zinc-800' : ''
                }`}
                data-testid={`lang-${lang.code}`}
              >
                <span className="text-white">{lang.nativeName}</span>
                {i18n.language === lang.code && (
                  <Check className="h-4 w-4 text-emerald-400" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
